import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { ConvoService } from '../../../service/ConvoService'
import convoStore from '../convo-store'
import convoUtils from './convo-utils'
import fetchFollows from './fetch-follows'
import { IConvo } from '../../../model/convo'

export default async function unfollowConvo(context: BareActionContext<ConvoState, RootState>, convo: IConvo)
{
  convoUtils.convoService.unfollow(convo).then((result: any) => {
    fetchFollows(context, convo)
  })

  return
}